// extracted by mini-css-extract-plugin
export default {"prefix":"styles_prefix__46-y-","number":"styles_number__6vGlV","numberInput":"styles_numberInput__Y+Cmh"};